import { defineTable } from "convex/server";
import { v } from "convex/values";
import { internalControl } from "../../lib/shared/validators";
import { modulesTypes } from "../permissions";
import { Id, TableNames } from "../../_generated/dataModel";

const validatorAction = v.union(
	v.literal("create"),
	v.literal("update"),
	v.literal("delete"),
);

export const validatorAuditLog = v.object({
	action: validatorAction,
	resourceType: modulesTypes,
	resourceId: v.optional(v.string()),
	timestamp: v.number(),
	metadata: v.optional(v.record(v.string(), v.any())),
	internalControl,
});

export const audit_logs = defineTable(validatorAuditLog)
	.index("by_resource", ["resourceType", "resourceId"])
	.index("by_timestamp", ["timestamp"])
	.index("by_company", ["internalControl.companyId", "timestamp"]);

export type AuditLogResourceId<T extends TableNames = TableNames> =
	`${T}:${string}`;

export function createAuditLog<T extends TableNames>(params: {
	action: string;
	resourceType: T;
	resourceId?: Id<T>;
	metadata?: Record<string, unknown>;
	internalControl: typeof internalControl;
}) {
	return {
		...params,
		resourceId: params.resourceId?.toString(),
		timestamp: Date.now(),
	};
}
